<template>
  <div class="container">
    <div class="row dado__head">
      <div class="col-12 col-lg-3">
        <div class="title">Dashboard</div>
      </div>
      <div class="col-12 col-lg-9">
        <div class="row dado__separately">
          <div class="col-12 col-md-3">
            <label class="dado__label">Country</label>
            <vue-select v-model="filters.country" :options="getCountriesOptions(true)" @change="onFilter"></vue-select>
          </div>
          <div class="col-12 col-md-3 partners-select" v-if="getAuthUser.role_name.toLowerCase() === 'admin' || getAuthUser.role_name.toLowerCase() === 'observer'">
            <label class="dado__label">Partner Organisation</label>
            <vue-select :settings="{multiple: true}" v-model="filters.partner" placeholder="All" :options="getPartnersOptions(true)" @change="onFilter"></vue-select>
            <span class="count" v-if="filters.partner.length > 1">({{filters.partner.length}})</span>
          </div>
          <div class="col-12 col-md-3">
            <label class="dado__label">Period between incident & survey</label>
            <vue-select v-model="filters.period" :options="getFilterOptions.periods" @change="onFilter"></vue-select>
          </div>
          <div class="col-12 col-md-3">
            <label class="dado__label">Year</label>
            <vue-select v-model="filters.year" :options="getFilterOptions.years" @change="onFilter"></vue-select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <v-sidebar/>
      <div class="col-12 col-lg-10">
        <div class="dashboard__box">
          <div class="dashboard__topic">Age/gender</div>
          <canvas id="chart__gender" class="dashboard__chart"></canvas>
          <div class="dashboard__btn" v-if="0">
            <button class="btn__extract">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path
                      d="M11 15.5834C10.6205 15.5834 10.3125 15.2754 10.3125 14.8959V0.6875C10.3125 0.307999 10.6205 0 11 0C11.3795 0 11.6875 0.307999 11.6875 0.6875V14.8959C11.6875 15.2754 11.3795 15.5834 11 15.5834Z"/>
                  <path
                      d="M11.0004 15.5835C10.8244 15.5835 10.6485 15.5165 10.5145 15.3817L6.8479 11.7151C6.57935 11.4465 6.57935 11.0112 6.8479 10.7424C7.11646 10.4739 7.55185 10.4739 7.82057 10.7424L11.0013 13.9233L14.1821 10.7424C14.4507 10.4739 14.8862 10.4739 15.1548 10.7424C15.4234 11.0112 15.4234 11.4465 15.1548 11.7151L11.488 15.3817C11.3524 15.5165 11.1765 15.5835 11.0004 15.5835Z"/>
                  <path
                      d="M19.4791 21.9999H2.52089C1.13028 21.9999 0 20.8696 0 19.479V15.354C0 14.9745 0.307999 14.6665 0.6875 14.6665C1.067 14.6665 1.375 14.9745 1.375 15.354V19.479C1.375 20.1106 1.88928 20.6249 2.52089 20.6249H19.4791C20.1107 20.6249 20.625 20.1106 20.625 19.479V15.354C20.625 14.9745 20.933 14.6665 21.3125 14.6665C21.692 14.6665 22 14.9745 22 15.354V19.479C22 20.8696 20.8697 21.9999 19.4791 21.9999Z"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="22" height="22"/>
                  </clipPath>
                </defs>
              </svg>
              Extract in Excel
            </button>
          </div>
        </div>
        <div class="dashboard__box">
          <div class="dashboard__topic">Which safety equipment is used when handling pesticides</div>
          <canvas id="chart__equipment" class="dashboard__chart"></canvas>
          <div class="dashboard__btn" v-if="0">
            <button class="btn__extract">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path
                      d="M11 15.5834C10.6205 15.5834 10.3125 15.2754 10.3125 14.8959V0.6875C10.3125 0.307999 10.6205 0 11 0C11.3795 0 11.6875 0.307999 11.6875 0.6875V14.8959C11.6875 15.2754 11.3795 15.5834 11 15.5834Z"/>
                  <path
                      d="M11.0004 15.5835C10.8244 15.5835 10.6485 15.5165 10.5145 15.3817L6.8479 11.7151C6.57935 11.4465 6.57935 11.0112 6.8479 10.7424C7.11646 10.4739 7.55185 10.4739 7.82057 10.7424L11.0013 13.9233L14.1821 10.7424C14.4507 10.4739 14.8862 10.4739 15.1548 10.7424C15.4234 11.0112 15.4234 11.4465 15.1548 11.7151L11.488 15.3817C11.3524 15.5165 11.1765 15.5835 11.0004 15.5835Z"/>
                  <path
                      d="M19.4791 21.9999H2.52089C1.13028 21.9999 0 20.8696 0 19.479V15.354C0 14.9745 0.307999 14.6665 0.6875 14.6665C1.067 14.6665 1.375 14.9745 1.375 15.354V19.479C1.375 20.1106 1.88928 20.6249 2.52089 20.6249H19.4791C20.1107 20.6249 20.625 20.1106 20.625 19.479V15.354C20.625 14.9745 20.933 14.6665 21.3125 14.6665C21.692 14.6665 22 14.9745 22 15.354V19.479C22 20.8696 20.8697 21.9999 19.4791 21.9999Z"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="22" height="22"/>
                  </clipPath>
                </defs>
              </svg>
              Extract in Excel
            </button>
          </div>
        </div>
        <div class="dashboard__box">
          <div class="dashboard__topic">For which cotton pests / diseases / weeds do you use most pesticides</div>
          <canvas id="chart__pesticides" class="dashboard__chart"></canvas>
          <div class="dashboard__btn" v-if="0">
            <button class="btn__extract">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path
                      d="M11 15.5834C10.6205 15.5834 10.3125 15.2754 10.3125 14.8959V0.6875C10.3125 0.307999 10.6205 0 11 0C11.3795 0 11.6875 0.307999 11.6875 0.6875V14.8959C11.6875 15.2754 11.3795 15.5834 11 15.5834Z"/>
                  <path
                      d="M11.0004 15.5835C10.8244 15.5835 10.6485 15.5165 10.5145 15.3817L6.8479 11.7151C6.57935 11.4465 6.57935 11.0112 6.8479 10.7424C7.11646 10.4739 7.55185 10.4739 7.82057 10.7424L11.0013 13.9233L14.1821 10.7424C14.4507 10.4739 14.8862 10.4739 15.1548 10.7424C15.4234 11.0112 15.4234 11.4465 15.1548 11.7151L11.488 15.3817C11.3524 15.5165 11.1765 15.5835 11.0004 15.5835Z"/>
                  <path
                      d="M19.4791 21.9999H2.52089C1.13028 21.9999 0 20.8696 0 19.479V15.354C0 14.9745 0.307999 14.6665 0.6875 14.6665C1.067 14.6665 1.375 14.9745 1.375 15.354V19.479C1.375 20.1106 1.88928 20.6249 2.52089 20.6249H19.4791C20.1107 20.6249 20.625 20.1106 20.625 19.479V15.354C20.625 14.9745 20.933 14.6665 21.3125 14.6665C21.692 14.6665 22 14.9745 22 15.354V19.479C22 20.8696 20.8697 21.9999 19.4791 21.9999Z"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="22" height="22"/>
                  </clipPath>
                </defs>
              </svg>
              Extract in Excel
            </button>
          </div>
        </div>
        <div class="dashboard__box">
          <div class="dashboard__topic">Percentage of people reporting signs and symptoms consistent with Acute Pesticide Poisoning</div>
          <div class="gender_filter text-right mb-3">
            <label class="dashboard__label d-inline-block">Gender:</label>
            <div class="dashboard__select d-inline-block text-left">
              <vue-select v-model="severity_selected_gender" :options="charts_genders"/>
            </div>
          </div>
          <div class="oneCanvas">
            <div class="dashboard__canvases">
              <canvas style="position: relative; left: -140px;" id="chart__donutOne" class="dashboard__chart"></canvas>
            </div>
            <div class="dashboard__information">
              <div class="dashboard__severe">
                Severe
                <span>{{ getStats.incidents != undefined ? getStats.incidents.data[severity_selected_gender][3] : 0 }} answers</span>
              </div>
              <div class="dashboard__moderate">
                Moderate
                <span>{{ getStats.incidents != undefined ? getStats.incidents.data[severity_selected_gender][2] : 0 }} answers</span>
              </div>
              <div class="dashboard__mild">
                Mild
                <span>{{ getStats.incidents != undefined ? getStats.incidents.data[severity_selected_gender][1] : 0 }} answers</span>
              </div>
              <div class="dashboard__noSigns">
                No signs and symptoms
                <span>{{ getStats.incidents != undefined ? getStats.incidents.data[severity_selected_gender][0] : 0 }} answers</span>
              </div>
            </div>
          </div>
          <div class="twoCanvas">
            <div class="dashboard__canvases">
              <canvas style="position: relative; left: -140px;" id="chart__donutTwo" class="dashboard__chart"></canvas>
            </div>
            <div class="dashboard__information">
              <div class="dashboard__green">
                Received medical assistance for reported signs and symptoms of acute pesticide poisoning
                <span>{{ getStats.medical_assistance != undefined ? getStats.medical_assistance.data[severity_selected_gender][1] : 0 }} answers</span>
              </div>
              <div class="dashboard__gray">
                No medical assistance received for signs and symptoms of acute pesticide poisoning. All respondents
                included
                <span>{{ getStats.medical_assistance != undefined ? getStats.medical_assistance.data[severity_selected_gender][0] : 0 }} answers</span>
              </div>
            </div>
          </div>
          <div class="dashboard__btn" v-if="0">
            <button class="btn__extract">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path
                      d="M11 15.5834C10.6205 15.5834 10.3125 15.2754 10.3125 14.8959V0.6875C10.3125 0.307999 10.6205 0 11 0C11.3795 0 11.6875 0.307999 11.6875 0.6875V14.8959C11.6875 15.2754 11.3795 15.5834 11 15.5834Z"/>
                  <path
                      d="M11.0004 15.5835C10.8244 15.5835 10.6485 15.5165 10.5145 15.3817L6.8479 11.7151C6.57935 11.4465 6.57935 11.0112 6.8479 10.7424C7.11646 10.4739 7.55185 10.4739 7.82057 10.7424L11.0013 13.9233L14.1821 10.7424C14.4507 10.4739 14.8862 10.4739 15.1548 10.7424C15.4234 11.0112 15.4234 11.4465 15.1548 11.7151L11.488 15.3817C11.3524 15.5165 11.1765 15.5835 11.0004 15.5835Z"/>
                  <path
                      d="M19.4791 21.9999H2.52089C1.13028 21.9999 0 20.8696 0 19.479V15.354C0 14.9745 0.307999 14.6665 0.6875 14.6665C1.067 14.6665 1.375 14.9745 1.375 15.354V19.479C1.375 20.1106 1.88928 20.6249 2.52089 20.6249H19.4791C20.1107 20.6249 20.625 20.1106 20.625 19.479V15.354C20.625 14.9745 20.933 14.6665 21.3125 14.6665C21.692 14.6665 22 14.9745 22 15.354V19.479C22 20.8696 20.8697 21.9999 19.4791 21.9999Z"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="22" height="22"/>
                  </clipPath>
                </defs>
              </svg>
              Extract in Excel
            </button>
          </div>
        </div>
        <div class="dashboard__box">
          <div class="dashboard__topic">Frequency of similar incidents consistent with acute pesticide poisoning over previous 12 months</div>
          <canvas id="chart__frequency" class="dashboard__frequency"></canvas>
          <div class="dashboard__btn" v-if="0">
            <button class="btn__extract">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path
                      d="M11 15.5834C10.6205 15.5834 10.3125 15.2754 10.3125 14.8959V0.6875C10.3125 0.307999 10.6205 0 11 0C11.3795 0 11.6875 0.307999 11.6875 0.6875V14.8959C11.6875 15.2754 11.3795 15.5834 11 15.5834Z"/>
                  <path
                      d="M11.0004 15.5835C10.8244 15.5835 10.6485 15.5165 10.5145 15.3817L6.8479 11.7151C6.57935 11.4465 6.57935 11.0112 6.8479 10.7424C7.11646 10.4739 7.55185 10.4739 7.82057 10.7424L11.0013 13.9233L14.1821 10.7424C14.4507 10.4739 14.8862 10.4739 15.1548 10.7424C15.4234 11.0112 15.4234 11.4465 15.1548 11.7151L11.488 15.3817C11.3524 15.5165 11.1765 15.5835 11.0004 15.5835Z"/>
                  <path
                      d="M19.4791 21.9999H2.52089C1.13028 21.9999 0 20.8696 0 19.479V15.354C0 14.9745 0.307999 14.6665 0.6875 14.6665C1.067 14.6665 1.375 14.9745 1.375 15.354V19.479C1.375 20.1106 1.88928 20.6249 2.52089 20.6249H19.4791C20.1107 20.6249 20.625 20.1106 20.625 19.479V15.354C20.625 14.9745 20.933 14.6665 21.3125 14.6665C21.692 14.6665 22 14.9745 22 15.354V19.479C22 20.8696 20.8697 21.9999 19.4791 21.9999Z"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="22" height="22"/>
                  </clipPath>
                </defs>
              </svg>
              Extract in Excel
            </button>
          </div>
        </div>
        <div class="dashboard__box">
          <div class="dashboard__topic">The number of work days lost due to acute health effects of pesticides</div>
          <canvas id="chart__workDays" class="dashboard__chart"></canvas>
          <div class="dashboard__btn" v-if="0">
            <button class="btn__extract">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path
                      d="M11 15.5834C10.6205 15.5834 10.3125 15.2754 10.3125 14.8959V0.6875C10.3125 0.307999 10.6205 0 11 0C11.3795 0 11.6875 0.307999 11.6875 0.6875V14.8959C11.6875 15.2754 11.3795 15.5834 11 15.5834Z"/>
                  <path
                      d="M11.0004 15.5835C10.8244 15.5835 10.6485 15.5165 10.5145 15.3817L6.8479 11.7151C6.57935 11.4465 6.57935 11.0112 6.8479 10.7424C7.11646 10.4739 7.55185 10.4739 7.82057 10.7424L11.0013 13.9233L14.1821 10.7424C14.4507 10.4739 14.8862 10.4739 15.1548 10.7424C15.4234 11.0112 15.4234 11.4465 15.1548 11.7151L11.488 15.3817C11.3524 15.5165 11.1765 15.5835 11.0004 15.5835Z"/>
                  <path
                      d="M19.4791 21.9999H2.52089C1.13028 21.9999 0 20.8696 0 19.479V15.354C0 14.9745 0.307999 14.6665 0.6875 14.6665C1.067 14.6665 1.375 14.9745 1.375 15.354V19.479C1.375 20.1106 1.88928 20.6249 2.52089 20.6249H19.4791C20.1107 20.6249 20.625 20.1106 20.625 19.479V15.354C20.625 14.9745 20.933 14.6665 21.3125 14.6665C21.692 14.6665 22 14.9745 22 15.354V19.479C22 20.8696 20.8697 21.9999 19.4791 21.9999Z"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="22" height="22"/>
                  </clipPath>
                </defs>
              </svg>
              Extract in Excel
            </button>
          </div>
        </div>
        <div class="dashboard__box">
          <div class="dashboard__head">
            <div class="dashboard__caption">% incidents associated with each pesticide</div>
            <div class="dashboard__lea">
              <label class="dashboard__label">Gender:</label>
              <div class="dashboard__select">
                <vue-select v-model="incidents_selected_gender" :options="charts_genders"/>
              </div>
            </div>
          </div>
          <canvas id="randomizeData" class="dashboard__frequency"></canvas>
          <div class="dashboard__info">
            <p class="severe">% incidents are severe</p>
            <p class="mild">% incidents are mild or moderate</p>
          </div>
          <div class="dashboard__btn" v-if="0">
            <button class="btn__extract">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                  <path
                      d="M11 15.5834C10.6205 15.5834 10.3125 15.2754 10.3125 14.8959V0.6875C10.3125 0.307999 10.6205 0 11 0C11.3795 0 11.6875 0.307999 11.6875 0.6875V14.8959C11.6875 15.2754 11.3795 15.5834 11 15.5834Z"/>
                  <path
                      d="M11.0004 15.5835C10.8244 15.5835 10.6485 15.5165 10.5145 15.3817L6.8479 11.7151C6.57935 11.4465 6.57935 11.0112 6.8479 10.7424C7.11646 10.4739 7.55185 10.4739 7.82057 10.7424L11.0013 13.9233L14.1821 10.7424C14.4507 10.4739 14.8862 10.4739 15.1548 10.7424C15.4234 11.0112 15.4234 11.4465 15.1548 11.7151L11.488 15.3817C11.3524 15.5165 11.1765 15.5835 11.0004 15.5835Z"/>
                  <path
                      d="M19.4791 21.9999H2.52089C1.13028 21.9999 0 20.8696 0 19.479V15.354C0 14.9745 0.307999 14.6665 0.6875 14.6665C1.067 14.6665 1.375 14.9745 1.375 15.354V19.479C1.375 20.1106 1.88928 20.6249 2.52089 20.6249H19.4791C20.1107 20.6249 20.625 20.1106 20.625 19.479V15.354C20.625 14.9745 20.933 14.6665 21.3125 14.6665C21.692 14.6665 22 14.9745 22 15.354V19.479C22 20.8696 20.8697 21.9999 19.4791 21.9999Z"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="22" height="22"/>
                  </clipPath>
                </defs>
              </svg>
              Extract in Excel
            </button>
          </div>
        </div>
        <div class="dashboard__box">
          <div class="dashboard__head">
            <div class="dashboard__caption">Map of reports</div>
            <div class="dashboard__lea">
              <label class="dashboard__label">Map:</label>
              <div class="dashboard__select">
                <vue-select v-model="map_selected_type" :options="map_select_types"/>
              </div>
            </div>
            <div class="dashboard__lea">
              <label class="dashboard__label">Gender:</label>
              <div class="dashboard__select">
                <vue-select v-model="map_selected_gender" :options="charts_genders"/>
              </div>
            </div>
          </div>
          <div id="map_area" style="height: 555px;">
            <div id="regions_div" v-show="map_selected_type == 'Regions'"></div>
            <div id="coords_div" v-show="map_selected_type == 'Coords'" class="h-100 w-100">
              <GmapMap :center="{lat:10, lng:10}" :options="regions_map_options" style="width: 100%; height: 100%">
                <GmapMarker
                    v-for="(marker, index) in markers"
                    :key="index"
                    :position="marker.coords"
                    :clickable="true"
                    :draggable="false"
                    @click="openWindow(marker)"
                />
                <gmap-info-window
                    @closeclick="window_open = false"
                    :opened="window_open"
                    :position="window_data.position">
                  <div v-html="window_data.text"></div>
                </gmap-info-window>
              </GmapMap>
            </div>
          </div>
          <div class="dashboard__btn" v-if="0">
            <button class="btn__extract">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                  <path
                      d="M11 15.5834C10.6205 15.5834 10.3125 15.2754 10.3125 14.8959V0.6875C10.3125 0.307999 10.6205 0 11 0C11.3795 0 11.6875 0.307999 11.6875 0.6875V14.8959C11.6875 15.2754 11.3795 15.5834 11 15.5834Z"/>
                  <path
                      d="M11.0004 15.5835C10.8244 15.5835 10.6485 15.5165 10.5145 15.3817L6.8479 11.7151C6.57935 11.4465 6.57935 11.0112 6.8479 10.7424C7.11646 10.4739 7.55185 10.4739 7.82057 10.7424L11.0013 13.9233L14.1821 10.7424C14.4507 10.4739 14.8862 10.4739 15.1548 10.7424C15.4234 11.0112 15.4234 11.4465 15.1548 11.7151L11.488 15.3817C11.3524 15.5165 11.1765 15.5835 11.0004 15.5835Z"/>
                  <path
                      d="M19.4791 21.9999H2.52089C1.13028 21.9999 0 20.8696 0 19.479V15.354C0 14.9745 0.307999 14.6665 0.6875 14.6665C1.067 14.6665 1.375 14.9745 1.375 15.354V19.479C1.375 20.1106 1.88928 20.6249 2.52089 20.6249H19.4791C20.1107 20.6249 20.625 20.1106 20.625 19.479V15.354C20.625 14.9745 20.933 14.6665 21.3125 14.6665C21.692 14.6665 22 14.9745 22 15.354V19.479C22 20.8696 20.8697 21.9999 19.4791 21.9999Z"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="22" height="22"/>
                  </clipPath>
                </defs>
              </svg>
              Extract in Excel
            </button>
          </div>
        </div>
        <div class="dashboard__cellar" v-if="0">
          <div class="dashboard__btn">
            <button class="btn__extract">
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path
                      d="M11 15.5834C10.6205 15.5834 10.3125 15.2754 10.3125 14.8959V0.6875C10.3125 0.307999 10.6205 0 11 0C11.3795 0 11.6875 0.307999 11.6875 0.6875V14.8959C11.6875 15.2754 11.3795 15.5834 11 15.5834Z"/>
                  <path
                      d="M11.0004 15.5835C10.8244 15.5835 10.6485 15.5165 10.5145 15.3817L6.8479 11.7151C6.57935 11.4465 6.57935 11.0112 6.8479 10.7424C7.11646 10.4739 7.55185 10.4739 7.82057 10.7424L11.0013 13.9233L14.1821 10.7424C14.4507 10.4739 14.8862 10.4739 15.1548 10.7424C15.4234 11.0112 15.4234 11.4465 15.1548 11.7151L11.488 15.3817C11.3524 15.5165 11.1765 15.5835 11.0004 15.5835Z"/>
                  <path
                      d="M19.4791 21.9999H2.52089C1.13028 21.9999 0 20.8696 0 19.479V15.354C0 14.9745 0.307999 14.6665 0.6875 14.6665C1.067 14.6665 1.375 14.9745 1.375 15.354V19.479C1.375 20.1106 1.88928 20.6249 2.52089 20.6249H19.4791C20.1107 20.6249 20.625 20.1106 20.625 19.479V15.354C20.625 14.9745 20.933 14.6665 21.3125 14.6665C21.692 14.6665 22 14.9745 22 15.354V19.479C22 20.8696 20.8697 21.9999 19.4791 21.9999Z"/>
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="22" height="22"/>
                  </clipPath>
                </defs>
              </svg>
              Extract in Excel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import * as VueGoogleMaps from 'vue2-google-maps'
  import {mapGetters, mapMutations, mapActions} from 'vuex'
  import Chart from 'chart.js'
  import labels from 'chartjs-plugin-labels'

  Vue.use(VueGoogleMaps, {
    load: {
      key: process.env.VUE_APP_API_MAPKEY,
      libraries: 'places',
    },
  })

  export default {
    name: "Dashboard",
    data() {
      return {
        filters: {
          country: '0',
          partner: [0],
          period: 'All',
          year: 'All',
        },
        genderOptions: [
          'All',
          'Male',
          'Female'
        ],
        charts_genders: ['ALL', 'MALE', 'FEMALE'],
        canvasGender: null,
        canvasEquipment: null,
        canvasPesticides: null,
        pesticides_selected_gender: 'ALL',

        canvasIncidents: null,
        severity_selected_gender: 'ALL',
        canvasIncidents2: null,
        incidents_selected_gender: 'ALL',

        canvasAssistance: null,
        canvasFrequency: null,
        frequency_selected_gender: 'ALL',
        canvasDaysMissed: null,
        daysmissed_selected_gender: 'ALL',

        map_select_types: ['Regions', 'Coords'],
        map_selected_type: 'Regions',
        map_selected_gender: 'ALL',

        regions_map_options: {
          zoom: 2,
          zoomControl: true,
          MapType: 'roadmap',
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: true,
          disableDefaultUi: false,
        },
        window_open: false,
        window_data: {
          position: {lat: 10, lng: 10},
          text: null,
        },
      }
    },
    computed: {
      ...mapGetters([
        'getAuthUser',
        'getCountriesOptions',
        'getPartnersOptions',
        'getFilterOptions',
        'getFilters',
        'getStats',
      ]),
      markers() {
        if (this.getStats.countries_markers)
          return this.getStats.countries_markers[this.map_selected_gender]
        return []
      }
    },
    created() {
      window.addEventListener("resize", this.myEventHandler);
    },
    destroyed() {
      window.removeEventListener("resize", this.myEventHandler);
    },
    mounted() {

      if (this.getAuthUser && this.getAuthUser.role_name === 'Admin') {
        this.queryRoles()
        this.queryPartners()
      }

      this.queryCountries()

      if (this.getAuthUser.partner_id) {
        this.filters.partner = [0]
        this.setStatsFilters(this.filters)
      }

      this.queryStats()
        .then(() => {
            let updateGender = setInterval(() => {
              if (typeof this.getStats.gender != "undefined") {
                this.chartGender()
                this.chartEquipment()
                this.chartPesticides()
                this.chartIncidents()
                this.chartIncidents2()
                this.chartAssistance()
                this.chartFrequency()
                this.chartDaysMissed()
                this.chartCountries()

                clearInterval(updateGender)
              }
            }, 100)
          }
        )

    },
    watch: {
      incidents_selected_gender(val) {
        this.canvasIncidents2.destroy()
        this.chartIncidents2()
      },
      severity_selected_gender(val) {
        this.canvasIncidents.destroy()
        this.chartIncidents()
        this.canvasAssistance.destroy()
        this.chartAssistance()
      },
      daysmissed_selected_gender(val) {
        this.canvasDaysMissed.destroy()
        this.chartDaysMissed()
      },
      map_selected_gender(val) {
        this.chartCountries()
      },
    },
    methods: {
      ...mapActions([
        'queryCountries',
        'queryRoles',
        'queryStats',
        'queryPartners',
      ]),
      ...mapMutations([
        'setStatsFilters'
      ]),
      onFilter() {
        this.clearCharts()
        this.setStatsFilters(this.filters)
        this.queryStats()
          .then(() => {
            let updateCharts = setInterval(() => {
              if (typeof this.getStats.gender != "undefined") {
                this.chartGender()
                this.chartEquipment()
                this.chartPesticides()
                this.chartIncidents()
                this.chartIncidents2()
                this.chartAssistance()
                this.chartFrequency()
                this.chartDaysMissed()
                this.chartCountries()

                clearInterval(updateCharts)
              }
            }, 100)
          })
      },
      clearCharts() {
        this.canvasGender.destroy()
        this.canvasEquipment.destroy()
        this.canvasPesticides.destroy()
        this.canvasIncidents.destroy()
        this.canvasIncidents2.destroy()
        this.canvasAssistance.destroy()
        this.canvasFrequency.destroy()
        this.canvasDaysMissed.destroy()
      },
      chartGender() {
        this.canvasGender = new Chart(document.getElementById("chart__gender"), {
          type: 'bar',
          data: {
            labels: this.getStats.gender.labels,
            datasets: [
              {
                label: "Male " + this.getStats.gender.all_male_count + ' (' + this.getStats.gender.all_male_percent + '%)',
                backgroundColor: "#64E969",
                data: this.getStats.gender.data.MALE,
                barThickness: 20,
              },
              {
                label: "Female " + this.getStats.gender.all_female_count + ' (' + this.getStats.gender.all_female_percent + '%)',
                backgroundColor: "#FFC700",
                data: this.getStats.gender.data.FEMALE,
                barThickness: 20,
              }
            ]
          },
          options: {
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                boxWidth: 21,
                fontColor: 'black',
                fontFamily: 'Montserrat',
                fontSize: 14
              }
            },
            scales: {
              yAxes: [{
                ticks: {
                  fontColor: 'black',
                  fontFamily: 'Montserrat',
                  fontSize: 14,
                  callback: function (value) {
                    return value + '%'
                  },
                },
                gridLines: {
                  borderDash: [4, 4],
                  color: "#dadada"
                },
              }],
              xAxes: [{
                ticks: {
                  beginAtZero: true,
                  fontColor: 'black',
                  fontFamily: 'Montserrat',
                  fontSize: 14,
                },
                gridLines: {
                  display: false
                }
              }],
            },
            tooltips: {
              mode: 'index',
              intersect: false,
              callbacks: {
                label: function (tooltipItem, data) {
                  return tooltipItem.value + '%';
                }
              }
            },
            plugins: {
              labels: false
            }
          }
        })
        this.canvasGender.generateLegend()
      },
      chartEquipment() {
        let self = this;
        this.canvasEquipment = new Chart(document.getElementById("chart__equipment"), {
          type: 'bar',
          data: {
            labels: this.getStats.equipment.labels,
            datasets: [
              {
                label: "Male " + this.getStats.equipment.all_male_count + ' (' + this.getStats.equipment.all_male_percent + '%)',
                backgroundColor: "#64E969",
                data: this.getStats.equipment.data.MALE,
                barThickness: 20,
              },
              {
                label: "Female " + this.getStats.equipment.all_female_count + ' (' + this.getStats.equipment.all_female_percent + '%)',
                backgroundColor: "#FFC700",
                data: this.getStats.equipment.data.FEMALE,
                barThickness: 20,
              }
            ]
          },
          options: {
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                boxWidth: 21,
                fontColor: 'black',
                fontFamily: 'Montserrat',
                fontSize: 14
              }
            },
            scales: {
              yAxes: [{
                ticks: {
                  fontColor: 'black',
                  fontFamily: 'Montserrat',
                  fontSize: 14,
                  callback: function (value) {
                    return value + '%'
                  },
                },
                gridLines: {
                  borderDash: [4, 4],
                  color: "#dadada"
                }
              }],
              xAxes: [{
                ticks: {
                  beginAtZero: true,
                  fontColor: 'black',
                  fontFamily: 'Montserrat',
                  fontSize: 12,
                  callback: function (value) {
                    return self.str_split(value, 9)
                  },
                },
                gridLines: {
                  display: false
                }
              }],
            },
            tooltips: {
              mode: 'index',
              intersect: false,
              callbacks: {
                label: function (tooltipItem, data) {
                  return tooltipItem.value + '%';
                }
              }
            },
            plugins: {
              labels: false
            }
          }
        })
      },
      chartPesticides() {
        this.canvasPesticides = new Chart(document.getElementById("chart__pesticides"), {
          type: 'bar',
          data: {
            labels: this.getStats.pesticides.labels,
            datasets: [{
              backgroundColor: "#00EDA6",
              data: this.getStats.pesticides.data,
              barThickness: 20,
            }]
          },
          options: {
            responsive: true,
            legend: {
              display: false,
            },
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  fontColor: 'black',
                  fontFamily: 'Montserrat',
                  fontSize: 14,
                  callback: function (value) {
                    return value + '%'
                  },
                },
                gridLines: {
                  borderDash: [4, 4],
                  color: "#dadada"
                },
              }],
              xAxes: [{
                ticks: {
                  beginAtZero: true,
                  fontColor: 'black',
                  fontFamily: 'Montserrat',
                  fontSize: 11,
                },
                gridLines: {
                  display: false
                }
              }],
            },
            tooltips: {
              mode: 'index',
              intersect: false,
              callbacks: {
                label: function (tooltipItem, data) {
                  return tooltipItem.value + '%';
                }
              }
            },
            plugins: {
              labels: false
            }
          }
        })
      },
      chartIncidents() {
        this.canvasIncidents = new Chart(document.getElementById("chart__donutOne"), {
          type: 'doughnut',
          data: {
            datasets: [{
              data: this.getStats.incidents.data[this.severity_selected_gender],
              backgroundColor: [
                "#cecece",
                "#ffc700",
                "#ff7a00",
                "#ff2c2c",
              ],
              // label: 'Dataset 1'
            }],
            labels: [
              'No Signs and symptoms',
              'Mild',
              'Moderate',
              'Severe',
            ]
          },
          options: {
            responsive: true,
            legend: {
              display: false,
            },
            title: {
              display: true,
              text: ''
            },
            animation: {
              animateScale: true,
              animateRotate: true
            },
            plugins: {
              labels: {
                fontSize: 16,
                fontColor: '#fff',
                fontStyle: 'bold',
              }
            }
          }
        })
      },
      chartIncidents2() {
        this.canvasIncidents2 = new Chart(document.getElementById("randomizeData").getContext("2d"), {
          type: 'bar',
          data: {
            labels: this.getStats.incidents.labels,
            datasets: [{
              barThickness: 20,
              label: '% incidents are severe',
              backgroundColor: '#ff2c2c',
              stack: 'Stack 0',
              data: this.getStats.incidents.data2[this.incidents_selected_gender].severe
            }, {
              barThickness: 20,
              label: '% incidents are mild or moderate',
              backgroundColor: '#ff9900',
              stack: 'Stack 0',
              data: this.getStats.incidents.data2[this.incidents_selected_gender].moderate
            }]
          },
          options: {
            title: {
              display: false,
            },
            legend: {
              display: false
            },
            tooltips: {
              mode: 'index',
              intersect: false,
              enabled: true,
            },
            animation: {
              duration: 1000,
              currentStep: 1,
            },
            responsive: true,
            scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [{
                stacked: true,
                scaleLabel: {
                  display: true,
                  labelString: 'Incidents Associated With Each Pesticide'
                }
              }]
            },
            plugins: {
              labels: false
            }
          }
        })
      },
      chartAssistance() {
        this.canvasAssistance = new Chart(document.getElementById("chart__donutTwo"), {
          type: 'doughnut',
          data: {
            datasets: [{
              data: this.getStats.medical_assistance.data[this.severity_selected_gender],
              backgroundColor: [
                "#cecece",
                "#64e969",
              ],
              label: 'Dataset 1'
            }],
            labels: this.getStats.medical_assistance.labels,
          },
          options: {
            responsive: true,
            legend: {
              display: false,
            },
            title: {
              display: true,
              text: ''
            },
            animation: {
              animateScale: true,
              animateRotate: true
            },
            plugins: {
              labels: {
                fontSize: 16,
                fontColor: '#fff',
                fontStyle: 'bold',
              }
            }
          }
        })
      },
      chartFrequency() {
        this.canvasFrequency = new Chart(document.getElementById("chart__frequency"), {
          type: 'bar',
          data: {
            labels: this.getStats.frequency.labels,
            datasets: [{
              backgroundColor: "#ffc700",
              data: this.getStats.frequency.data,
              barThickness: 20,
            }]
          },
          options: {
            responsive: true,
            layout: {
              padding: {
                bottom: 25
              }
            },
            title: {
              display: true,
              position: 'left',
              text: '% responses'
            },
            legend: {
              display: false,
            },
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  fontColor: 'black',
                  fontFamily: 'Montserrat',
                  fontSize: 14,
                  callback: function (value) {
                    return value + '%'
                  },
                },
                gridLines: {
                  borderDash: [4, 4],
                  color: "#dadada"
                },
              }],
              xAxes: [{
                ticks: {
                  beginAtZero: true,
                  fontColor: 'black',
                  fontFamily: 'Montserrat',
                  fontSize: 14,
                },
                gridLines: {
                  display: false
                }
              }],
            },
            tooltips: {
              mode: 'index',
              intersect: false,
              callbacks: {
                label: function (tooltipItem, data) {
                  return tooltipItem.value + '%';
                }
              }
            },
            plugins: {
              labels: false
            }
          },
          plugins: [
            {
              afterDraw: function (chart, options) {
                let ctx = chart.chart.ctx;
                ctx.save();
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.font = 'bold 11px Montserrat';
                ctx.fillText('Number of incidents over previous 12 months', chart.chart.width / 2, chart.chart.height - 15);
                ctx.restore();
              }
            }
          ]
        });
      },
      chartDaysMissed() {
        this.canvasDaysMissed = new Chart(document.getElementById("chart__workDays"), {
          type: 'bar',
          data: {
            datasets: [
              {
                data: this.getStats.lost_days.data,
                fill: false,
                backgroundColor: "#64E969",
              }
            ],
            labels: this.getStats.lost_days.labels,
          },
          options: {
            spanGaps: false,
            responsive: true,
            layout: {
              padding: {
                bottom: 25
              }
            },
            title: {
              display: true,
              position: 'left',
              text: '% responses'
            },
            legend: {
              display: false,
            },
            elements: {
              line: {
                tension: 0.000001
              }
            },
            plugins: {
              filler: {
                propagate: false
              },
              labels: false
            },
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  fontColor: 'black',
                  fontFamily: 'Montserrat',
                  fontSize: 14,
                  callback: function (value) {
                    return value + '%'
                  },
                },
                gridLines: {
                  borderDash: [4, 4],
                  color: "#dadada"
                },
              }],
              xAxes: [{
                ticks: {
                  beginAtZero: true,
                  fontColor: 'black',
                  fontFamily: 'Montserrat',
                  fontSize: 14,
                },
                gridLines: {
                  display: false
                }
              }],
            },
            tooltips: {
              mode: 'index',
              intersect: false,
              callbacks: {
                label: function (tooltipItem, data) {
                  return tooltipItem.value + '%';
                }
              }
            },
          },
          plugins: [
            {
              afterDraw: function (chart, options) {
                let ctx = chart.chart.ctx;
                ctx.save();
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.font = 'bold 11px Montserrat';
                ctx.fillText('Days', chart.chart.width / 2, chart.chart.height - 15);
                ctx.restore();
              }
            }
          ]
        })
      },
      chartCountries() {
        google.charts.load('current', {
          'packages': ['geochart'],
          // Note: you will need to get a mapsApiKey for your project.
          // See: https://developers.google.com/chart/interactive/docs/basic_load_libs#load-settings
          'mapsApiKey': 'AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY'
        })
        google.charts.setOnLoadCallback(() => {
          let data = new google.visualization.DataTable();
          data.addColumn('string', 'Country');
          data.addColumn('number', 'Reports');
          data.addColumn({type: 'string', role: 'tooltip'});
          data.addRows(this.getStats.countries.data[this.map_selected_gender])
          let options = {
            legend: 'none',
            width: document.getElementById('map_area').clientWidth,
            height: document.getElementById('map_area').clientHeight,
          }
          let chart = new google.visualization.GeoChart(document.getElementById('regions_div'))
          chart.draw(data, options)
        })
      },
      openWindow(marker) {
        this.window_data.position = marker.coords
        this.window_data.text = '<div><b>Date:</b> ' + marker.date + '</div>' +
          '<div><b>Country:</b> ' + marker.country + '</div>' +
          '<div><b>Report:</b> <a href="/results/' + marker.id + '" target="_blank">' + marker.id + '</a></div>'

        this.window_open = true
      },
      myEventHandler(e) {
        this.chartCountries()
      },
      str_split(str, maxwidth) {
        let sections = [];
        let words = str.split(" ");
        let temp = "";

        words.forEach(function (item, index) {
          if (temp.length > 0) {
            let concat = temp + ' ' + item;

            if (concat.length > maxwidth) {
              sections.push(temp);
              temp = "";
            } else {
              if (index == (words.length - 1)) {
                sections.push(concat);
                return;
              } else {
                temp = concat;
                return;
              }
            }
          }

          if (index == (words.length - 1)) {
            sections.push(item);
            return;
          }

          if (item.length < maxwidth) {
            temp = item;
          } else {
            sections.push(item);
          }

        });

        return sections;
      }
    }
  }
</script>

<style>
.partners-select .select2-selection__rendered{
  padding: 0 10px !important;
  display:flex !important;
  position: relative;
}
.partners-select .count{
  position: absolute;
  right:15px;
  bottom:0;
  text-align: right;
  padding:2px 10px 0 5px;
  width:60px;
  height:48px;
  display:flex;
  justify-content: flex-end;
  align-items: center;
  color:green;
  background: linear-gradient(to right, rgba(255,255,255,0.5) 10%, rgba(255,255,255,1) 30%)

}
.select2-container--default .select2-selection--multiple .select2-selection__rendered li{
  background: none !important;
  border:none !important;
  margin:0 !important;
}
</style>